module.exports = __webpack_public_path__ + "static/media/helport.3a6f808f.png";